import "./navbar.js";

const cookieName = "showLoginForm";
const newsLocalStorage = "news-pop"

$(document).ready(function() {
    eiq.registerLoginFormToggle();
    const form = document.getElementById("eiq-login-form");

    if (form != null) {
        var showForm = eiq.getCookie(cookieName);
        if (showForm !== null && showForm !== "") {
            if (form.classList.contains("d-none")) {
                eiq.showForm(form);
            }
        }
    }

    //show auto popup on smaller screen
    var width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
    var wideEnough = width > 500;

    var newsPopTextDifferent = true;
    var newsPopText = $('#news-button.has-popover').data("original-title");

    if (localStorage && wideEnough) {
        var lastNewsPopText = localStorage.getItem(newsLocalStorage);
        newsPopTextDifferent = newsPopText != lastNewsPopText || !lastNewsPopText;

        if(newsPopTextDifferent)
            localStorage.setItem(newsLocalStorage, newsPopText); //set the last viewed news item
    }

    var showPopover = wideEnough && newsPopTextDifferent
    if (showPopover) {
        $("#news-button.has-popover").popover('show');
    }

    $('#news-button').click(function () {
        $('#news-modal').modal('show');

        if (showPopover) {
            $('#news-button.has-popover').popover('dispose');
        }
    });

    $.get('/news/index', function (content) {
        $("#news-modal .modal-body").html(content);
    });
});


const eiq = {    
    registerLoginFormToggle() {
        const link = document.getElementById("eiq-login-more");
        const username = document.getElementById("eiq-username");

        if(!link) return;

        link.onclick = handleClick;

        function handleClick(event) {
            const form = document.getElementById("eiq-login-form");            

            if (form.classList.contains("d-none")) {               
                eiq.showForm(form);
                eiq.setCookie(cookieName, true, 365); 
            } else {               
                eiq.hideForm(form);
                eiq.deleteCookie(cookieName);               
            }
        }
    },    
    setCookie(cname, cvalue, exdays) {
        const millisecsInADay = 24 * 60 * 60 * 1000;
        var d = new Date();
        d.setTime(d.getTime() + (exdays * millisecsInADay));
        var expires = "expires=" + d.toUTCString();        
        document.cookie = `${cname}=${cvalue}; ${expires}; path=/;`
    },
    getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    },
    deleteCookie(cname) {        
        eiq.setCookie(cname, "", -1);
    },
    showForm(form) {
        const link = document.getElementById("eiq-login-more");
        const username = document.getElementById("eiq-username");
        link.textContent = link.getAttribute("data-default-hide-text");
        form.classList.remove("d-none");
        username.focus();
    },
    hideForm(form) {
        const link = document.getElementById("eiq-login-more");
        link.textContent = link.getAttribute("data-default-text");
        form.classList.add("d-none");
    }
};
